import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';

import { takeUntil } from 'rxjs';

import { UserExperience } from '@models/ebo/shared/user-experience';
import { UserExperienceService } from '@services/user-experience.service';
import { SummitDisposing } from '@summit/models';

import { SummitDialogDirective } from '@summit/form';
import { DialogService } from 'primeng/dynamicdialog';
import { PremiumDialog } from './premium-dialog.component';

@Injectable()
export class FlagGuard extends SummitDisposing implements CanActivate {
  //*noUnusedParameters private router = inject(Router);
  private uxService = inject(UserExperienceService);
  private ux: UserExperience;
  private sDialog = new SummitDialogDirective();
  constructor(private dialogService: DialogService) {
    super();
    this.uxService.currentUserExperience.pipe(takeUntil(this.disposing$)).subscribe((ux) => {
      this.ux = ux;
    });
  }

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    if (this.ux?.isLoggedIn()) {
      // logged in so return true
      const features = this.ux.activeEmployee.features;
      if (features.driverLogs === false) {
        if (_route.queryParams['view'] === 'Wage') {
          this.showPremiumDialog();
          return false;
        } else if (this.ux.menuBarSelection?.flags?.includes('driverLogs')) {
          this.showPremiumDialog();
          return false;
        }
      }
      if (features.payroll === false) {
        if (this.ux.menuBarSelection?.flags?.includes('payroll')) {
          this.showPremiumDialog();
          return false;
        }
        if (_route.data['flags']?.includes('payroll')) {
          this.showPremiumDialog();
          return false;
        }
      }
      if (features.scheduler === false) {
        if (_route.data['flags']?.includes('scheduler')) {
          this.showPremiumDialog();
          return false;
        }
      }
      return true;
    }
    // For anonymous users (not logged in), allow access by default
    // Flag guard only restricts premium features for logged-in users
    return true;
  }

  showPremiumDialog() {
    this.sDialog.show(PremiumDialog, { header: 'Premium Feature' }, () => {
      //nop
    });
  }
}
